import { render, staticRenderFns } from "./AddAssignmentDialog.vue?vue&type=template&id=f8da8224"
import script from "./AddAssignmentDialog.vue?vue&type=script&lang=js"
export * from "./AddAssignmentDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports